import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { PageShell } from "@/components/site-layout";
import { verifyPayment } from "@/lib/api";

export default function PaymentCallbackPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'failed'>('processing');

  useEffect(() => {
    const processPayment = async () => {
      const params = new URLSearchParams(window.location.search);
      const reference = params.get('reference');

      if (!reference) {
        setStatus('failed');
        setTimeout(() => navigate("/payment/failed"), 2000);
        return;
      }

      try {
        await verifyPayment(reference);
        setStatus('success');
        setTimeout(() => navigate("/payment/success?reference=" + reference), 2000);
      } catch (error) {
        console.error('Payment verification failed:', error);
        setStatus('failed');
        setTimeout(() => navigate("/payment/failed?reference=" + reference), 2000);
      }
    };

    processPayment();
  }, [navigate]);

  return (
    <PageShell>
      <section className="container-x flex min-h-[70vh] items-center justify-center py-20">
        <div className="max-w-lg rounded-3xl border border-border bg-card p-10 text-center shadow-[var(--shadow-elegant)]">
          {status === 'processing' && (
            <>
              <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-primary/10 text-primary animate-spin">
                <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
              </div>
              <h1 className="mt-6 text-3xl font-bold">Processing Payment</h1>
              <p className="mt-3 text-muted-foreground">Please wait while we verify your payment...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-green-500/10 text-green-500">
                <div className="h-8 w-8 bg-green-500 rounded-full" />
              </div>
              <h1 className="mt-6 text-3xl font-bold">Payment Successful!</h1>
              <p className="mt-3 text-muted-foreground">Redirecting you to the confirmation page...</p>
            </>
          )}
          {status === 'failed' && (
            <>
              <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-red-500/10 text-red-500">
                <div className="h-8 w-8 bg-red-500 rounded-full" />
              </div>
              <h1 className="mt-6 text-3xl font-bold">Payment Failed</h1>
              <p className="mt-3 text-muted-foreground">Redirecting you to the error page...</p>
            </>
          )}
        </div>
      </section>
    </PageShell>
  );
}
